import { ProgressBar, Typography } from "@kyan/ui";

import { formatValue } from "#/utils/valueFormatters";

import { useNextReferralController } from "./NextReferral.controller";

export const NextReferral = () => {
  const { value, maxValue, isAccountConnected } = useNextReferralController();

  if (!isAccountConnected) return null;

  return (
    <div className="flex min-w-47 flex-col items-center justify-start gap-1 sm:items-end">
      <Typography>Volume to fill for next referral</Typography>
      <div className="grid justify-items-center gap-1 sm:justify-items-end">
        <ProgressBar
          isTextHidden
          value={value}
          max={maxValue}
          variant="tertiary"
          barClassName="h-1.25"
          className="mt-1 w-28"
        />
        <Typography medium primary size={16}>
          {formatValue(value, { template: "0" })} /{" "}
          {formatValue(maxValue, { template: "0 USDC" })}
        </Typography>
      </div>
    </div>
  );
};
